import React, { useEffect, useState } from "react";
import * as style from "./Featuregroups.module.scss";
import { Stack } from "@mui/material";
import {
  TextArea,
  Panel,
  Dropdown,
  DropdownOption,
  Toggle,
  Divider,
} from "cprime-foundational-components";
import {
  getApplicationsWithFeatures,
  mapFeatureToGroup,
} from "../../services/RequestAccess/RequestAccess";
import { useParams } from "react-router-dom";
import { triggerToast } from "../../utils/toast";

import Button from "../../Components/Common/CprimeButton";
import Typography from "../../Components/Common/CprimeText";
const AddFeaturePanel = ({
  onClose,
  open,
  setTriggerEffect,
  triggerEffect,
}: {
  onClose: () => void;
  open: boolean;
  setTriggerEffect: any;
  triggerEffect: any;
}) => {
  const [toggleState, setToggleState] = useState(false);
  const scssClass = style as any;
  const { id } = useParams();
  const [appsData, setAppsData] = useState<any[]>([]);
  const [applicationOptions, setApplicationOptions] = useState<
    DropdownOption[]
  >([]);
  const [featureOptions, setFeatureOptions] = useState<DropdownOption[]>([]);
  const [selectedApp, setSelectedApp] = useState<any>(null);
  const [selectedFeature, setSelectedFeature] = useState<any>(null);
  const [selectedAppOption, setSelectedAppOption] = useState<DropdownOption[]>(
    [],
  );
  const [loading, setLoading] = useState(false);
  const [selectedFeatureOption, setSelectedFeatureOption] = useState<
    DropdownOption[]
  >([]);

  const [description, setDescription] = useState("");

  const getAppsWithFeatures = async () => {
    const response = await getApplicationsWithFeatures();
    const apps = response?.data || [];
    setAppsData(apps);
    // Map applications to dropdown options
    const appOptions = apps?.map((app: any) => ({
      label: app?.app_name,
      value: app?.app_id,
    }));
    setApplicationOptions(appOptions);
  };

  const handleApplicationChange = (field: DropdownOption[]) => {
    if (!field?.length) return;
    // Update selected option in state
    setSelectedAppOption(field);
    const selected = field[0];
    const app = appsData?.find((a) => a?.app_id === selected?.value);
    setSelectedApp(app);
    setSelectedFeature(null);
    setDescription("");
    setSelectedFeatureOption([]);

    const featureOpts =
      app?.features?.map((feature: any) => ({
        label: feature?.feature_name,
        value: feature?.id,
      })) || [];

    setFeatureOptions(featureOpts);
  };

  const handleFeatureChange = (field: DropdownOption[]) => {
    if (!field?.length || !selectedApp) return;
    // Update selected option in state
    setSelectedFeatureOption(field);

    const selected = field[0];
    const feature = selectedApp?.features?.find(
      (f: any) => f?.id === selected?.value,
    );

    setSelectedFeature(feature);
    setDescription(feature?.feature_description || "");
  };

  useEffect(() => {
    getAppsWithFeatures();
  }, []);

  const handleCreate = async () => {
    const payload = {
      feature_id: selectedFeature?.id,
      group_id: Number(id),
      is_open_to_all: toggleState,
    };

    try {
      setLoading(true);
      const response = await mapFeatureToGroup(payload);
      if (response?.error) {
        triggerToast(`${response?.error}`, "error");
      } else if (response?.status === "SUCCESS") {
        triggerToast(`${response?.message}`, "success");
        onClose();
        setTriggerEffect(!triggerEffect);
      }
    } catch (err) {
      // console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Panel
        id="valueStreamSidePanel"
        sx={{
          "& .MuiDrawer-root": { padding: "0" },
          "& .MuiPaper-root": {
            width: "fit-content",
            minWidth: "800px",
            top: "104px",
            height: "calc(100vh - 104px)",
            gap: "24px",
          },
        }}
        title={"Add Feature"}
        side="right"
        onClose={onClose}
        open={open}
        body={
          <div
            style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}
          >
            <div>
              <Divider
                variant={"fullWidth"}
                sx={{
                  marginBottom: "15px",
                  width: "100%",
                  marginLeft: "0px !important",
                  backgroundColor: "#f8f8f9 !important",
                }}
              />
              <Typography className={scssClass?.textDescription}>
                Feature Group Details
              </Typography>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "0.75rem",
                }}
                className={scssClass?.fieldsContent}
              >
                <div>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      lineHeight: "16px",
                      paddingBottom: "0.5rem",
                    }}
                  >
                    Application
                  </Typography>
                  <Dropdown
                    placeholder="Select"
                    fullWidth
                    optionsTextLimit={200}
                    style={{ width: "100%" }}
                    multiple={false}
                    options={applicationOptions}
                    selectedOptions={selectedAppOption}
                    onChange={handleApplicationChange}
                  />
                </div>
                <div>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      lineHeight: "16px",
                      paddingBottom: "0.5rem",
                    }}
                  >
                    Feature
                  </Typography>
                  <Dropdown
                    placeholder="Select"
                    optionsTextLimit={200}
                    fullWidth
                    style={{ width: "100%" }}
                    multiple={false}
                    options={featureOptions}
                    selectedOptions={selectedFeatureOption}
                    onChange={handleFeatureChange}
                    disabled={!selectedApp}
                  />
                </div>
                <TextArea
                  label="Description"
                  aria-label="minimum height"
                  minRows={3}
                  placeholder="Enter Description"
                  disabled
                  style={{ width: "99.5%" }}
                  value={description}
                  onChange={() => {}}
                  maxLength={500}
                />
                <div>
                  <p
                    style={{
                      fontSize: "12px",
                      color: "#58595B",
                      margin: "0 0 8px 0",
                    }}
                  >
                    Visible to Users
                  </p>
                  <Toggle
                    onChange={() => setToggleState(!toggleState)}
                    checked={toggleState}
                    sx={{
                      overflow: "visible",
                      marginBottom: "4px",
                      "& .MuiSwitch-thumb": {
                        marginTop: "4px",
                      },
                    }}
                    toggledText={toggleState ? "On" : "Off"}
                    size="small"
                  />
                </div>
              </div>
            </div>

            <div
              style={{
                marginTop: "auto",
                width: `calc(100% - 48px)`,
                position: "absolute",
                bottom: "0",
              }}
            >
              <Divider />
              <Stack direction="row" justifyContent="flex-end" p="1rem 1.5rem">
                <Stack direction="row" gap={2}>
                  <Button variant="tertiary" onClick={onClose}>
                    Cancel
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleCreate}
                    disabled={!selectedFeature?.id}
                    loading={loading}
                  >
                    Create
                  </Button>
                </Stack>
              </Stack>
            </div>
          </div>
        }
      />
      <span
        style={{
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          position: "fixed",
          width: "100vw",
          height: "calc(100vh - 104px)",
          zIndex: 1100,
          top: "104px",
          left: 0,
        }}
      ></span>
    </>
  );
};

export default AddFeaturePanel;
